import React, {
	forwardRef,
	ForwardRefRenderFunction,
	InputHTMLAttributes,
	useState,
} from "react";

interface ICurrencyInputProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
	onChange: (
		event: React.ChangeEvent<HTMLInputElement>,
		value: number,
		maskedValue: string,
	) => void;
}

const CurrencyInputBase: ForwardRefRenderFunction<
	HTMLInputElement,
	ICurrencyInputProps
> = ({ onChange, className, ...rest }, ref) => {
	const [displayValue, setDisplayValue] = useState("");

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value.replace(/[^\d]/g, "");
		const numberValue = parseInt(value, 10) / 100;

		const formattedValue = new Intl.NumberFormat("pt-BR", {
			style: "currency",
			currency: "BRL",
			minimumFractionDigits: 2,
		}).format(numberValue);

		setDisplayValue(formattedValue);
		onChange(e, numberValue, formattedValue);
	};

	return (
		<div
			className={`bg-white flex flex-col sm:flex-row p-3 rounded-lg items-start sm:items-center w-full max-w-md mx-auto ${className}`}
		>
			<span className="text-base text-[#505050] font-normal mb-2 sm:mb-0 sm:mr-4">
				Valor
			</span>
			<input
				type="text"
				ref={ref}
				{...rest}
				value={displayValue}
				onChange={handleChange}
				className="flex-1 text-xl sm:text-2xl text-gray-800 font-semibold border-none outline-none w-full bg-transparent"
				placeholder="R$ 0,00"
				color="#000"
			/>
		</div>
	);
};

export const CurrencyInput = forwardRef(CurrencyInputBase);

export default CurrencyInput;
